module.exports = __webpack_public_path__ + "img/contactless.61b033cd.svg";